<script setup>
import key from '../composables/key'
const { t } = useI18n({ useScope: 'global' })

     const locale = ref(useI18n().locale.value)
     const randowCode = ref('4589');
    const title = ref('0'); // 称谓
    const name = ref(''); // 姓名
    const phone = ref(''); // 电话
    const email = ref(''); // 邮箱
    const message = ref(''); // 留言
    const code = ref(''); // 验证码
    const region = ref("HK");
    const other_information = ref("");
    const isNotName = ref(false);
    const isNotPhone = ref(false);
    const isNotEmail = ref(false);
    const isNotMessage = ref(false);
    const isNotCode = ref(false);
    const isNotService = ref(false);
    const isNotAgree = ref(false);
    const isNotTitle = ref(false);
    const isSmsCode = ref(false);
    const isagree = ref(0);
    const smsLoading = ref(false);
    const vercode = ref("");
    const captcha = ref('');
    const image_code = ref("");
    const No = ref('852')
    const titleName = ref('');
    const vName = ref('请输入您的姓名')
    const vPhone = ref('请输入您的联系电话')
    const vEmail = ref('请输入您的电子邮箱')
    const vMessage = ref('请输入您的留言')
    const vCode = ref('请输入您的验证码')
    // 使用 reactive 定义对象或数组类型的响应式数据
    const information = ref([]);
    const regionList = reactive([
      {
        chat: "",
        charList: [
          {
            No: "86",
            code: "CN",
            country: "中国",
            en_name: "China"
          },
          {
            No: "852",
            code: "HK",
            country: "中国香港",
            en_name: "Hong Kong"
          },
          {
            No: "853",
            code: "MO",
            country: "中国澳门",
            en_name: "Macau"
          },
          {
            No: "886",
            code: "TW",
            country: "中国台湾",
            en_name: "Taiwan"
          }
        ]
      }
    ]);
    const Chat = ref('A');
    const charList = ref([]);
    const fromChar = ref([]);
    const isregion = ref(false);
    const smsBtnText =  ref(t('hqyzm'));


    watch(isagree, (newVal) => {
      if (newVal) {
        isNotAgree.value = false;
      }
    });

    watch(information, (newVal) => {
      if (newVal.length) {
        isNotService.value = false;
      }
    });

    watch(title, (newVal) => {
      if (+newVal) {
        isNotTitle.value = false;
      }
    });

    onMounted(() => {
      for (let i = 0; i < 26; i++) {
        fromChar.value.push(String.fromCharCode(65 + i));
      }
      getRegionListPost();
      if (locale.value === 'hk') {
        vName.value = t(vName.value);
        vPhone.value = '請輸入您的聯繫電話';
        vEmail.value = t(vEmail.value);
        vMessage.value = t(vMessage.value);
        vCode.value = t(vCode.value);
      }
      if (locale.value === 'en') {
        vName.value = 'Please enter your name';
        vPhone.value = 'Please enter your contact number';
        vEmail.value = 'Please enter your email';
        vMessage.value = 'Please enter your message';
        vCode.value = 'Please enter your verification code';
      }
      if (locale.value === 'hk') {
        titleName.value = t('方德证券-了解方德_联系我们');
        document.title = t('方德证券-了解方德_联系我们');
      } else if (locale.value === 'en') {
        titleName.value = 'Forthright Securities';
        document.title = 'Forthright Securities';
      } else {
        titleName.value = '';
      }
    })

    const gethost = () => {
      let hostname = location.hostname;
      let path = 'https://apitrade.fdzq.com';
      if (hostname.includes('10.253') || hostname.includes('172.17.') || hostname.includes('dev-') || hostname.includes('localhost')) {
        path = 'https://dev1-apitrade.fdzq.com';
      }
      return path;
    }

    const getSmsCode = async () => {
      if (smsLoading.value) return;
      if (!phone.value) {
        alert(t('sjhmbnwk'));
        return;
      }
      if (image_code.value && !vercode.value) {
        alert(t('txyzmbnwk'));
        return;
      }
      smsLoading.value = true;
      const _t = (Date.parse(new Date()) / 1000).toString();
      const res = await getSendSms({
        region: region.value,
        mobile: phone.value,
        image_code: vercode.value,
        _t: _t,
        _sign: key._sign(phone.value, _t)
      })
      if (res.data.status === 0) {
          countDown((s) => {
            smsBtnText.value = t('cf') + ' ' + s + 's';
          }, () => {
            smsBtnText.value = t('cxhq');
            smsLoading.value = false;
          });
        } else if (res.data.status === 1005) {
          alert(res.info);
          createCode();
          smsLoading.value = false;
        } else {
          smsLoading.value = false;
          alert(res.info);
        }
      // axios.post(gethost() + '/hk/contact_us/send_sms', ).then(res => {
      //   res = res.data;

      // });
    }

    const countDown = (countingFn, endFn) => {
      let time = 60;
      countingFn(time);
      window.countTimer = setInterval(() => {
        time--;
        if (time === 0) {
          clearInterval(window.countTimer);
          endFn();
        } else {
          countingFn(time);
        }
      }, 1000);
    }

    const regionClick = (item) => {
      No.value = item.No;
      region.value = item.code;
      isregion.value = false;
    }

    const createCode = async () => {
      const _t = (Date.parse(new Date()) / 1000).toString();
      const res = await getImageCode({
        type: 3,
        useZh: 0,
        _t: _t,
        _sign: key._sign(phone.value, _t)
      })
      if (res.status === 0) {
          image_code.value = res.data.data.image_code;
        } else {
          alert(res.info);
        }
      // axios.post(gethost() + '/user/index/imageCode', ).then(res => {
      //   res = res.data;

      // });
    }

    const getRegionListPost = async () => {
      const res = await getRegionList ()
      if (res.data.status === 0) {
          let zm = '';
          fromChar.value.forEach((ele, i) => {
            res.data.data.forEach((item, index) => {
              zm = locale.value === 'en' ? item.en_name.charAt(0) : py.getCamelChars(item.country).charAt(0);
              if (zm === ele) {
                if (ele === Chat.value) {
                  charList.push(item);
                } else {
                  regionList.push({
                    chat: Chat.value,
                    charList: charList
                  });
                  charList.length = 0;
                  Chat.value = ele;
                  charList.push(item);
                }
              }
            });
          });
          regionList.push({
            chat: Chat.value,
            charList: charList
          });
        }
      // axios('https://apitrade.fdzq.com/user/login/get_region_list').then((res) => {


      // });
    }

    const changeValue = () => {
      if (name.value) {
        isNotName.value = false;
      }
      if (phone.value) {
        isNotPhone.value = false;
      }
      if (email.value) {
        isNotEmail.value = false;
      }
      if (information.length) {
        isNotService.value = false;
      }
      if (code.value) {
        isNotCode.value = false;
      }
      if (+title.value) {
        isNotTitle.value = false;
      }
      if (isagree.value) {
        isNotAgree.value = false;
      }
      if (vercode.value) {
        isimageCode.value = false;
      }
      if (captcha.value) {
        isSmsCode.value = false;
      }
    }
    const sendMsg = async () => {
  let errFlag = false;
  let titleName = ''; // 称谓

  // 校验输入
  if (!+title.value) {
    isNotTitle.value = true;
    errFlag = true;
  }
  if (!name.value) {
    isNotName.value = true;
    errFlag = true;
  }
  if (!phone.value) {
    isNotPhone.value = true;
    errFlag = true;
  }
  if (!email.value) {
    isNotEmail.value = true;
    errFlag = true;
  }
  if (!information.value.length) {
    isNotService.value = true;
    errFlag = true;
  }
  if (!captcha.value) {
    isSmsCode.value = true;
    errFlag = true;
  }
  if (!isagree.value) {
    isNotAgree.value = true;
    errFlag = true;
  }

  if (errFlag) return;

  switch (+title.value) {
    case 1:
      titleName = '先生';
      break;
    case 2:
      titleName = '小姐';
      break;
    case 3:
      titleName = '太太';
      break;
    case 4:
      titleName = '女士';
      break;
  }

  // let hostname = location.hostname;
  // let url = 'https://w1.fdzq.com/Api/hk/contact_us';
  // // 测试环境
  // if (hostname.includes('10.253') || hostname.includes('192.168.') || hostname.includes('dev-') || hostname.includes('localhost')) {
  //   url = 'https://dev2-www.fdzq.com/Api/hk/contact_us';
  // }

  // 转fromData格式
      try {
        const _t = (Date.parse(new Date()) / 1000).toString();
        const res = await getContactUs({
          type: 1,
          title: titleName,
          name: name.value,
          phone: phone.value.replace(/\s*/g, ""),
          email: email.value.replace(/\s*/g, ""),
          message: message.value,
          region: region.value, // 假设你已经在 setup() 函数中定义了 region 响应式数据
          other_information: other_information.value, // 假设你已经在 setup() 函数中定义了 other_information 响应式数据
          information: information.value.join(','),
          captcha: captcha.value,
          _t: _t,
          _sign: key._sign(phone.value, _t)
        })
        if (res.data.status == 0) {
          clearInterval(window.countTimer);
          alert(locale.value === 'en' ? 'Sent successfully' : locale.value === 'hk' ? '發送成功' : '发送成功');
          title.value = 1;
          name.value = '';
          email.value = '';
          phone.value = '';
          message.value = '';
          // 假设你已经在 setup() 函数中定义了 code 响应式数据
          // code.value = '';
          information.value = [];
          isagree.value = false;
          other_information.value = '';
          captcha.value = '';
          smsBtnText.value = t('hqyzm');
        } else {
          alert(res.info);
        }
      } catch (error) {
        console.log(error)
      }


  // axios.post(url, )
  //   .then(res => {

  //   }).catch(err => {
  //     console.log(err.response.data.info);
  //   });
}

</script>

<template>
  <div ml="8%">
    <div w="95%" mt-24 mb-24>
      <div id="page-contact">
    <div class="about-warp__right--title">
      {{ $t('lxwm') }}
    </div>
    <div class="about-warp__right--content contact-box">
      <div class="contact-map  mobile" :class="{'en': locale === 'en'}">
        <div class="map-mark"></div>
        <div class="map-box">
          <ul>
            <li><span>{{ $t('fdzqyxgs|xgzhdfdz') }}
                    <br>{{ $t('134-136hzyjtrsbxds19-20l') }}</span></li>
            <li><span>{{ '400-100-1359/8522957-6133' }}</span></li>
            <li><span>{{ '8522957-6166' }}</span></li>
            <li><span>{{ $t('dy|info@forthright-sec.com') + ' | info@forthright-sec.com' }}</span></li>
          </ul>
        </div>
      </div>
      <div class="contact-form" >
        <div class="salutation">
          <label><input type="radio" class="radio" name="salutation" value="1"
                        v-model="title"><i></i>{{ $t('xs') }}</label>
          <label><input type="radio" class="radio" name="salutation" value="4"
                        v-model="title"><i></i>{{ $t('ns') }}</label>
        </div>
        <div class="tips" style="top: -14px;" v-show="isNotTitle">{{ $t('qxzcw') }}</div>


        <p>
          <em class="star-red">*</em>{{ $t('xm') }}
        </p>
        <input type="text" class="input" name="" id="name" :placeholder="vName"
               autofocus="autofocus" v-model="name" @input="changeValue"/>
        <div class="tips" v-show="isNotName">{{ $t('xmbnwkqzxsr') }}</div>


        <p>
          <em class="star-red">*</em>{{ $t('lxdh') }}
        </p>
        <div class="phone">

          <div class="region" :class="{'region2':No.length==3}">
            <span  @click="isregion=!isregion">+{{No}}</span>
            <ul class="regionList" v-show="isregion">
              <li v-for="(item,index) in regionList" :key="index">
                <ul>
                  <li v-if="item.chat">{{item.chat}}</li>
                  <li @click.stop="regionClick(ele)" :class="{'active':ele.No==No}" v-for="(ele,i) in item.charList" :key="i">+{{ele.No}}<span>{{locale === 'en'?ele.en_name:ele.country}}</span></li>
                </ul>
              </li>
            </ul>
          </div>
          <input type="text" class="input" name="" id="tel" :placeholder="vPhone" v-model.trim="phone" @input="changeValue"/>
        </div>
        <div class="tips" v-show="isNotPhone">{{ $t('lxdhbnwkqzxsr') }}</div>



        <div style="position: relative;display: flex;margin-bottom:15px" v-if="image_code">
            <input style="width: 100%;" type="text" @input="changeValue" class="input input2" name="" id="code" :placeholder="$t('qsutxyazm')" v-model="vercode"/>
            <img  :src="'data:image/jpeg;base64,'+image_code" alt="" srcset="" @click="createCode" style="height: 36px; display: inline-block;" />
        </div>

        <p>
          <em class="star-red">*</em>{{ $t('yzm') }}
        </p>
        <div style="position: relative;display: flex;margin-bottom:15px">
          <input style="width: 100%;" type="text"  @input="changeValue" class="input input2" name="" id="code" :placeholder="$t('qsrdxyzm')" v-model="captcha"/>
          <div class="sendcode" :class="{disabled: smsLoading}" @click="getSmsCode">
            <span>{{smsBtnText}}</span>
          </div>
        </div>
        <div class="tips" v-show="isSmsCode">{{ $t('yzmbnwkqzxsr') }}</div>


        <p>
          <em class="star-red" style="margin-left:13px">*</em>{{ $t('dzyx') }}
        </p>
        <input type="text" class="input" name="" id="mail" :placeholder="vEmail" v-model.trim="email" @input="changeValue"/>
        <div class="tips" v-show="isNotEmail">{{ $t('dzyxbnwkqzxsr') }}</div>


        <p>
          <em class="star-red" style="margin-left:13px"></em>{{ $t('ly') }}
        </p>
        <textarea  name="" class="input" :placeholder="vMessage" id="idea" v-model="message" @input="changeValue"> </textarea>
        <div class="tips tips-msg" v-show="isNotMessage">{{ $t('lybnwkqzxsr') }}</div>
        <p style="margin-top: 30px;margin-bottom: 16px;" >
          <em class="star-red">*</em>{{ $t('nxljsmfw') }}
        </p>
        <div class="salutation salutation2">
          <label><input type="checkbox" class="radio" value="1" @input="changeValue" v-model="information"><i></i>{{ $t('zqjyuyw') }}</label> <br/>
          <label><input type="checkbox" class="radio" value="2" @input="changeValue" v-model="information"><i></i>{{ $t('tzjyfw') }}</label><br/>
          <label><input type="checkbox" class="radio" value="3"  @input="changeValue" v-model="information"><i></i>{{ $t('zjzth') }}</label><br/>
          <label><input type="checkbox" class="radio" value="4"  @input="changeValue" v-model="information"><i></i>{{ $t('qtfw') }}</label>
        </div>
        <textarea  name=""  v-show="information.join(',').indexOf('4')!=-1" class="input"  style="padding:0"  v-model="other_information"> </textarea>

        <div class="tips tips-msg" v-show="isNotService">{{ $t('qxznxljdfw') }}</div>
        <!-- <p style="margin-top: 30px;" >
          <em class="star-red">*</em>{{ $t('yzm') }}
        </p> -->
        <!-- <div style="position: relative;display: flex;">
          <input style="width: 80%;" type="text" class="input" name="" id="code" :placeholder="vCode" v-model="code" @input="changeValue"/>
          <img v-if="randowCode" :src="randowCode" alt="" srcset="" @click="createCode" style="height: 35px; display: inline-block;" />
        </div> -->
        <!-- <div class="tips" v-show="isNotCode">{{ $t('yzmbnwkqzxsr') }}</div> -->

        <div class="salutation salutation3" style="width: 500px;margin-bottom:33px;margin-top: 30px;">
          <label style="color:#868E95"><input type="checkbox" class="radio" name="salutation" @input="changeValue" value="1" v-model="isagree"><i></i><span><span> {{ $t('wyydbtyfdzq') }}</span><a :href="locale === 'en'?'https://forthright-sec.com.hk/en/service/tabDetail?id=764':locale === 'hk'?'https://forthright-sec.com.hk/hk/service/tabDetail?id=764':'https://forthright-sec.com.hk/service/tabDetail/?id=764'" target='_blank' style="color:#317EF2 !important;">{{ $t('sytk') }}</a></span></label>
        </div>
        <div class="tips" v-show="isNotAgree">{{ $t('qsyfwsytkhhh') }}</div>
        <div class="content">
          <div class="zm_h">{{$t('zm1-h')}}</div>
          <div class="zm_p">{{$t('zm1-p')}}</div>
          <div class="zm_h">{{$t('zm2-h')}}</div>
          <div class="zm_p">{{$t('zm2-p')}}</div>
          <div class="zm_h">{{$t('zm3-h')}}</div>
          <div class="zm_p">{{$t('zm3-p')}}</div>
          <div class="zm_li">{{$t('zm3-li1')}}</div>
          <div class="zm_li">{{$t('zm3-li2')}}</div>
          <div class="zm_li">{{$t('zm3-li3')}}</div>
          <div class="zm_li">{{$t('zm3-li4')}}</div>
          <div class="zm_li">{{$t('zm3-li5')}}</div>
          <div class="zm_li">{{$t('zm3-li6')}}</div>
          <div class="zm_li">{{$t('zm3-li7')}}</div>
          <div class="zm_li">{{$t('zm3-li8')}}</div>
          <div class="zm_li">{{$t('zm3-li9')}}</div>
          <div class="zm_li">{{$t('zm3-li10')}}</div>
          <div class="zm_li">{{$t('zm3-li11')}}</div>
          <div class="zm_li">{{$t('zm3-li12')}}</div>
          <div class="zm_p">{{$t('zm4-p')}}</div>
          <div class="zm_h">{{$t('zm5-h')}}</div>
          <div class="zm_p">{{$t('zm5-p')}}</div>
          <div class="zm_li">{{$t('zm5-li1')}}</div>
          <div class="zm_li">{{$t('zm5-li2')}}</div>
          <div class="zm_li">{{$t('zm5-li3')}}</div>
          <div class="zm_li">{{$t('zm5-li4')}}</div>
          <div class="zm_h">{{$t('zm6-h')}}</div>
          <div class="zm_p">{{$t('zm6-p',{emial: 'info@forthright-sec.com'})}}</div>
          <div class="zm_p">{{$t('zm7-p')}}</div>
          <div class="zm_p">{{$t('zm8-p')}}</div>
          <div class="zm_h">{{$t('zm9-h')}}</div>
          <div class="zm_p">{{$t('zm9-p')}}</div>
          <div class="zm_p">{{$t('zm10-p',{emial: 'info@forthright-sec.com'})}}</div>
          <div class="zm_h">{{$t('zm11-h')}}</div>
          <div class="zm_p">{{$t('zm11-p')}}</div>
        </div>
        <button class="btn-idea" @click="sendMsg">{{ $t('fsly') }}</button>
      </div>
      <div class="contact-map web" :class="{'en': locale === 'en'}">
        <div class="map-mark"></div>
        <div class="map-box">
          <ul>
            <li><span>{{ $t('fdzqyxgs|xgzhdfdz') }}
                    <br>{{ $t('134-136hzyjtrsbxds19-20l') }}</span></li>
            <li><span>{{ '400-100-1359/8522957-6133' }}</span></li>
            <li><span>{{'8522957-6166' }}</span></li>
            <li><span>{{ $t('dy|info@forthright-sec.com') + ' | info@forthright-sec.com' }}</span></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
    </div>

  </div>
</template>
<style lang="less" scoped>
@import "../../assets/less/main.less";
@import "../assets/css/about.less";
.salutation3{
  label{
    input[type='radio'],input[type='checkbox']{
      & + i {
        position: relative;
        top: -1px;
      }
    }
  }
}
@media screen and (max-width: 420px) {
  body {
    #page-contact {
      .contact-box {
        .contact-form {
          width: 100%;

          input[type='text'] {
            width: 100%;
          }

          textarea {
            width: 100%;
          }

          .btn-idea {
            display: block;
            float: none;
            margin: 20px auto;
          }
        }

        .contact-map.mobile {
          display: inline-block!important;
        }

        .contact-map.web {
          display: none!important;
        }

        .contact-map.web {
          display: none;
        }

        .contact-map {
          width: 100%;
          margin-top: 0px!important;
          margin-bottom: 20px;

          .map-mark {
            top: 281px;
            width: 40px;
            height: 40px;
            left: 1px;
          }

          .map-box {
            height: 250px;
            width: 324px;
            top: 27px !important;
            left: 21px !important;

            ul {
              left: 61px;
              top: 12px;
            }
          }
        }
        .content{
          width: 100%;
        }
        .salutation3{
          width: 100% !important;
          label{
            display: flex !important;
            align-items: flex-start;
             input[type='radio'],input[type='checkbox']{
                & + i {
                  position: relative;
                  top: 1px;
                }
            }
          }
        }
      }

    }

  }
}

#page-contact {


  .contact-map.mobile {
    display: none!important;
  }

  .contact-map.web {
    display: inline-block!important;
  }

  .contact-box {

    .contact-form {
      input::-webkit-input-placeholder {
        color: #9B9B9B;
      }

      textarea::-webkit-input-placeholder {
        color: #9B9B9B;
      }

      vertical-align: top;
      width: 360px;
      // padding-top: 20px;
      display: inline-block;
      .codeCanvas{
        position: absolute;
        bottom: 50%;
        right: 0;
        transform: translateY(-50%);
      }
      .tips {
        font-size: 12px;
        color: #D43F38;
        line-height: 14px;
        padding-left: 22px;
        position: relative;
        top: -30px;
      }

      .tips-msg {
        top: 0;
      }

      .salutation {
        margin-bottom: 20px;
        padding-left: 5px;

        label {
          cursor: pointer;
          display: inline-block;
          margin-right: 20px;
          .font-size-line(14, 20);
          vertical-align: middle;
          position: relative;
        }

        input[type='radio']{
          vertical-align: middle;
          margin-right: 2px;
          position: absolute;
          clip: rect(0, 0, 0, 0);
          & + i {
            display: inline-block;
            vertical-align: middle;
            width: 16px;
            height: 16px;
            background-color: #F5F5F5;
            border: 1px solid #E6E9ED;
            border-radius: 50%;
            margin-right: 6px;
            padding: 5px 5px;
            flex-shrink: 0;
          }
        }
        input[type='checkbox']{
          vertical-align: middle;
          margin-right: 2px;
          position: absolute;
          clip: rect(0, 0, 0, 0);
          & + i {
            display: inline-block;
            vertical-align: middle;
            width: 16px;
            height: 16px;
            background-color: #F5F5F5;
            border: 1px solid #E6E9ED;
            margin-right: 6px;
            padding: 5px 5px;
            flex-shrink: 0;
            position: relative;
            top: -1px;
          }
        }

        input[type='radio']:checked {
          & + i {
            // border-color: #D54745;
            background: url(https://imgoss.fdzq.com/go_fd_co/fd-1652254140-6qsg03.png);
            background-size:100%;
            background-color: none;
            border:none;
          }
        }
       input[type='checkbox']:checked {
          & + i {
            // border-color: #D54745;
            background: url(https://imgoss.fdzq.com/go_fd_co/fd-1652334465-tlb6g3.png);
            background-size:100%;
            background-color: none;
            border:none;
          }
        }
      }
      .salutation3{
          input[type='checkbox']{
          vertical-align: middle;
          margin-right: 2px;
          position: absolute;
          clip: rect(0, 0, 0, 0);
          & + i {
            display: inline-block;
            vertical-align: middle;
            width: 16px;
            height: 16px;
            background-color: #F5F5F5;
            border: 1px solid #E6E9ED;
            margin-right: 6px;
            border-radius: 50%;
            padding: 5px 5px;
            flex-shrink: 0;
          }
        }

         input[type='checkbox']:checked {
          & + i {
            // border-color: #D54745;
            background: url(https://imgoss.fdzq.com/go_fd_co/fd-1652254409-xjbo9n.png);
            background-size:100%;
            background-color: none;
            border:none;
          }
        }
      }
      .salutation2{
        padding-left: 20px;
        margin-bottom: 0px;
        label{
          margin-bottom: 12px;
        }
      }

      span {
        display: inline-block;
        text-indent: 0;
        margin-bottom: 3px;
        font-size: 14px;
        color: #06234E;
      }

      .star-red {
        opacity: 0.8;
        font-size: 14px;
        color: #D43F38;
        margin: 0 9px 0 8px;
      }

      input[type='text'] {
        border: 0;
        outline: 0;
        border-bottom: 2px solid #EFEFEF;
        font-size: 14px;
        width: 360px;
        padding: 7px 22px;
        margin-bottom: 34px;
        margin-top: 5px;
        opacity: 0.8;
        color: #06234E;

        &:focus {
          border-color: #D43F38;
        }
      }

      textarea {
        font-size: 14px;
        border: 0;
        outline: 0;
        border-bottom: 2px solid #EFEFEF;
        width: 360px;
        padding: 7px 22px;
        // height: 120px;
        max-height: 120px;
        max-width: 360px;
        opacity: 0.8;
        color: #06234E;

        &:focus {
          border-color: #D43F38;
        }
      }
    }

    .contact-map {
      vertical-align: top;
      display: inline-block;
      width: 385px;
      height: 360px;
      //margin-left: 10px;
      margin-top: 97px;
      background: url("https://tg.fdzq.com/img/forthright-sec/images/about/map@2x.png") bottom no-repeat;
      background-size: 390px 360px;
      position: relative;

      &.en {
        margin-top: 85px;

        .map-box {
          top: 5px;
          height: 286px;
          background: url("https://tg.fdzq.com/img/forthright-sec/images/about/CombinedShape_en@2x.png") bottom no-repeat;
          background-size: 346px 286px;
        }
      }

      .map-mark {
        top: 264px;
        width: 40px;
        height: 40px;
        left: 6px;
        position: absolute;
        background: url("https://tg.fdzq.com/img/forthright-sec/images/about/point.png") center no-repeat;
      }

      .map-box {
        top: 58px;
        left: 21px;
        position: absolute;
        width: 346px;
        height: 232px;
        background: url("https://tg.fdzq.com/img/forthright-sec/images/about/CombinedShape@2x.png") bottom no-repeat;
        background-size: 346px 268px;

        ul {
          position: absolute;
          left: 65px;
          top: 15px;

          li {
            margin-bottom: 18px;
            position: relative;
            padding-right: 24px;

            &:before {
              content: '';
              width: 24px;
              height: 24px;
              position: absolute;
              left: -40px;
              top: -2px;
            }

            &:nth-child(1):before {
              background: url("https://tg.fdzq.com/img/forthright-sec/images/about/icons/aboutus_icons_1.png") center no-repeat;
            }

            &:nth-child(2):before {
              background: url("https://tg.fdzq.com/img/forthright-sec/images/about/icons/aboutus_icons_2.png") center no-repeat;
            }

            &:nth-child(3):before {
              background: url("https://tg.fdzq.com/img/forthright-sec/images/about/icons/aboutus_icons_3.png") center no-repeat;
            }

            &:nth-child(5):before {
              background: url("https://tg.fdzq.com/img/forthright-sec/images/about/icons/aboutus_icons_4.png") center no-repeat;
            }

            &:nth-child(4):before {
              background: url("https://tg.fdzq.com/img/forthright-sec/images/about/icons/aboutus_icons_5.png") center no-repeat;
              background-size: 24px 24px;
            }

            span {
              text-indent: 0;
              opacity: 0.8;
              font-size: 14px;
              color: #06234E;
              line-height: 20px;
              margin-bottom: 0;
            }
          }
        }
      }
    }

    .btn-idea {
      margin-top: 30px;
      margin-bottom: 50px;
      float: left;
      cursor: pointer;
      background: #D43F38;
      border-radius: 3px;
      width: 180px;
      height: 48px;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 48px;
      text-align: center;
      border: 0;
      outline: 0;

      &:hover {
        background: #E74A43;
      }
    }
  }
  .content{
    width: 756px;
    max-height: 145px;
    background: #FFFFFF;
    border: 1px solid #F4F4F4;
    overflow-y:auto;
    padding: 0 20px;
    padding-top: 15px;
    color: #333333;
    &::-webkit-scrollbar{
      width: 8px;
      height: 16px;
      background-color: #fff;
    }
    &::-webkit-scrollbar-thumb{
      background: #BEC4CA;
      border-radius: 4px;
    }
    .zm_h{
      color: #333333;
      font-size: 15px;
      font-weight: 800;
      margin-bottom: 10px;
    }
    .zm_p{
      font-size: 14px;
      margin-bottom: 10px;
    }
    .zm_li{
      font-size: 14px;
      margin-bottom: 10px;
      margin-left: 10px;
    }
  }
  .phone{
    display: flex;
    position: relative;
    .region{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #D54745;
      line-height: 14px;
      position: absolute;
      top: 14px;
      left: 21px;
      cursor: pointer;
      span{
        color: #D54745;
        margin-left: 0px;
        position: absolute;
        padding-right: 15px;
        z-index: 9;
      }
      &::after{
        content: '';
        width: 10px;
        height: 5px;
        background: url('https://imgoss.fdzq.com/go_fd_co/fd-1652253756-xtu7ah.png') no-repeat;
        background-size: 100%;
        position: absolute;
        right: -40px;
        top: 4px;
        z-index: 9;
      }
      .regionList{
        width: 363px;
        max-height: 333px;
        background: #FFFFFF;
        border: 1px solid #F1F1F1;
        position: absolute;
        left: -24px;
        top: 21px;
        z-index: 1;
        padding-left: 22px;
        overflow-y: auto;
         &::-webkit-scrollbar{
          width: 8px;
          height: 16px;
          background-color: #fff;
        }
        &::-webkit-scrollbar-thumb{
          background: #BEC4CA;
          border-radius: 4px;
        }
        li{
          ul{
            li{
              border-bottom: 1px solid #F4F4F4;
              height: 38px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #868E95;
              line-height: 38px;
              display: flex;
              align-items: center;
              position: relative;
              span{
                color: #333333;
                position: absolute;
                left: 100px;
                top: 0;
                bottom: 0;
                margin: auto;
              }
            }
          }

        }
        .active{
          color: #D54745;
          span{
            color: #D54745;
          }
        }
      }
    }
    .region2{
        &::after{
           content: '';
            width: 10px;
            height: 5px;
            background: url('https://imgoss.fdzq.com/go_fd_co/fd-1652253756-xtu7ah.png') no-repeat;
            background-size: 100%;
            position: absolute;
            right: -48px;
            top: 4px;
        }
    }
    input{
      padding-left: 86px !important;
    }
  }
  .sendcode{
  background: #D43F38;
  color: #FFFFFF;
  font-size: 16px;
  height: 30px;
  width: 90px;
  line-height: 30px;
  position: absolute;
  text-align: center;
  border-radius: 5px;
  top: 0;
  bottom: 31px;
  margin: auto;
  right: 5px;
  cursor: pointer;
  span{
    font-size: 16px !important;
    color: #FFFFFF !important;
  }
}
}

.disabled {
  color: #fff;
}
</style>
